var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimdiAnladimApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 230,
    viewBox: "0 0 97 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1686_707)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    transform: "matrix(-1 0 0 1 64 40)",
    fill: "#2C2C60"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6191 50.2005C55.5128 50.799 55.0594 50.8897 53.9712 51.5064C53.4815 51.7965 53.2276 51.4701 53.5722 51.0167C54.3521 50.001 55.2045 49.4388 56.0569 49.0398C56.4921 48.8403 57 49.1305 57 49.6202C57 49.8741 56.8367 50.0917 56.6191 50.2005Z",
    fill: "#FF6175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9736 49.6022C52.756 50.1282 52.3751 50.0375 52.357 49.4572C52.357 48.1876 52.6835 47.2082 53.1187 46.374C53.3364 45.9387 53.9167 45.8661 54.2069 46.247C54.352 46.4465 54.352 46.7186 54.2613 46.9362C53.7535 48.0969 53.4452 48.4415 52.9736 49.6022Z",
    fill: "#FF6175"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7066 50.1283C49.7635 49.2759 49.2738 48.369 48.9655 47.4804C48.8022 47.027 49.1287 46.5373 49.6184 46.5917C49.8723 46.6098 50.0536 46.7912 50.1625 47.027C50.6703 48.1695 50.7066 48.6411 51.2325 49.7837C51.4683 50.3096 51.1237 50.5273 50.7066 50.1283Z",
    fill: "#FF6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6957 60.1936C41.7682 60.1755 41.8227 60.0848 41.7864 60.0123C41.4237 58.9604 41.0609 58.1986 41.5143 57.7633C41.8589 57.4188 42.5662 57.4369 43.1103 57.5094C43.2736 57.5276 43.4187 57.3825 43.3824 57.2193C43.2192 56.4213 43.1647 55.7502 43.5637 55.4056C43.9446 55.061 44.8514 55.2787 45.5406 55.46C45.7038 55.4963 45.8308 55.3149 45.722 55.188C41.5687 49.6382 40.7163 49.0216 40.8433 48.3868C41.2242 46.5006 47.717 51.8327 48.3155 52.3406C51.2355 54.8071 52.8677 56.8021 52.8677 56.8021L53.2486 56.3124C53.4662 56.0404 53.702 55.7683 53.9559 55.4963C54.6632 54.7527 55.298 54.3174 55.425 54.2267H55.4431C55.7514 54.0091 56.1686 53.991 56.5313 54.2086C56.7489 54.3356 56.9121 54.5532 56.9666 54.8071C57.0754 55.2243 56.9122 55.6414 56.5676 55.8772L56.223 56.1129C55.5882 56.6208 54.2642 57.8722 53.829 59.4682C53.7201 59.8853 53.3574 60.1755 52.9221 60.2118C52.904 60.2118 52.8859 60.2118 52.8496 60.2118C52.3962 60.2118 52.0153 59.9216 51.8884 59.4863V59.4682C50.4919 56.4757 46.121 51.0529 43.1466 49.1123C41.2242 47.8609 41.3511 48.6951 41.6776 49.0941C42.004 49.5113 43.0741 50.3274 47.2817 55.7865C47.3905 55.9316 47.4087 56.1492 47.2999 56.3124C47.1729 56.4938 46.9371 56.5301 46.7558 56.4394C46.1391 56.1311 45.0509 55.8046 44.6882 56.1129C44.5613 56.2218 44.3436 56.6026 44.8152 57.9628C44.8696 58.0898 44.8514 58.2349 44.7789 58.3437C44.6701 58.5432 44.4343 58.5976 44.2348 58.5251C43.7814 58.3256 42.9834 58.1805 42.7295 58.4344C42.6388 58.5251 42.403 58.9241 42.9834 60.3206C43.0378 60.4475 43.0197 60.5926 42.9471 60.7196C42.8746 60.8465 42.7476 60.9191 42.6025 60.9191C42.4212 60.9372 41.8408 61.0279 41.7138 61.3544C41.5687 61.6627 41.7138 62.2068 43.2192 63.3312C43.7632 63.7302 43.1829 64.2381 42.6207 63.8753C41.5143 63.168 40.3536 61.4994 40.6438 60.8465C40.8796 60.375 41.333 60.2843 41.6957 60.1936Z",
    fill: "#21DDB9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1686_707",
    x: -66,
    y: 0,
    width: 230,
    height: 230,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 60
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1686_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1686_707",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimdiAnladimApp);
export default __webpack_public_path__ + "static/media/simdi-anladim-app.e06c30d8d9c3d3d671925b8b4bcb8a2d.svg";
export { ForwardRef as ReactComponent };